import { useInjection } from "@linkfluence/core/di";
import { UserRepositoryUID } from "@linkfluence/core/user/repositories/UserRepo";
import { useQuery } from "@tanstack/react-query";
import { UserRepository } from "../repositories/UserRepository";

export function useCurrentUserDiscoveryPreferences(
  pid: number,
  workspaceId: number
) {
  const repository = useInjection<UserRepository>(UserRepositoryUID);
  const {
    data,
    isLoading: loading,
    isError,
  } = useQuery(["/user/getDiscoveryPreferences", pid, workspaceId], () => {
    return repository.getDiscoveryPreferences(pid, workspaceId);
  });
  return {
    loading,
    data,
    error: isError,
  };
}
